import { render, staticRenderFns } from "./game-month-rounds.vue?vue&type=template&id=d0d732a6&scoped=true"
import script from "./game-month-rounds.vue?vue&type=script&lang=js"
export * from "./game-month-rounds.vue?vue&type=script&lang=js"
import style0 from "./game-month-rounds.vue?vue&type=style&index=0&id=d0d732a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d732a6",
  null
  
)

export default component.exports